// extracted by mini-css-extract-plugin
export var layoutContainer = "_5z-0";
export var layoutContainerNoRounding = "_5z-6";
export var layoutContainerOpen = "_5z-5";
export var layoutContainerResizing = "_5z-1";
export var mainContent = "_5z-2";
export var resizeDivider = "_5z-3";
export var slidePanel = "_5z-4";